var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('RegisterTemplate',{attrs:{"title":_vm.$t('verificationStatus.accountOpening.title'),"activeTab":_vm.activeTab,"tabs":_vm.tabs,"type":"OpenAccount"}})}
var staticRenderFns = []

export { render, staticRenderFns }